import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from 'hooks';
import { homeForRole } from 'config/roles';
import LoadingScreen from 'components/feedback/LoadingScreen';

/**
 * Inverse of ProtectedRoute — used for login/register/forgot-password. If a
 * user is already authenticated, bounce them to wherever they were headed
 * (a deep link captured by ProtectedRoute) or, failing that, their role's
 * home. This is what turns a successful login into a role-based redirect.
 */
export default function PublicOnlyRoute() {
  const { user, role, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return <LoadingScreen />;

  if (user) {
    const target = location.state?.from?.pathname || homeForRole(role);
    return <Navigate to={target} replace />;
  }

  return <Outlet />;
}
